import React from 'react'
import { ThemeToggle as ThemeToggleBase } from '../../ui'
import { put } from '../../../api/request'

interface ThemeToggleProps {
  showLabel?: boolean
}

/**
 * App-connected theme toggle: renders the `ui` ThemeToggle primitive and
 * persists the chosen mode to the user's account preferences.
 */
export const ThemeToggle: React.FC<ThemeToggleProps> = ({ showLabel: _showLabel = false }) => (
  <ThemeToggleBase
    onModeChange={async mode => {
      await put('/preferences/modes', { mode })
    }}
  />
)

export default ThemeToggle
